import $ from 'jquery'
import 'select2-bundle'
import FormatUtils from '@/utils/formatUtils'
import { IdTextPair, LoadingData } from 'select2'

// Initialize select2 with ~ as a delimiter to float things left and right.
// Used by various dropdowns on the product page.
export default {
  basicDelimiter($selector: JQuery) {
    return $selector.select2({
      minimumResultsForSearch: Infinity,
      escapeMarkup(text) {
        // Expecting a single &nbsp; between the texts to float
        const texts = text.split('\xa0')
        if (texts.length === 2) {
          return (
            '<span>' +
            texts[0] +
            '</span>' +
            '<span class="pull-right">' +
            texts[1] +
            '</span>' +
            // Since these are floated, we need to clear the floats in order to occupy space,
            // but the selects are added dynamically, so just add space in markup.
            // https://stackoverflow.com/questions/33372298/select2-js-how-to-align-two-items-inside-option-element#comment54540066_33372626
            '<br/>'
          )
        } else {
          return text
        }
      }
    })
  },

  priceTemplate(
    option: IdTextPair | LoadingData,
    discountPercentage: number
  ): JQuery<HTMLElement> {
    const quantity = $(option.element!).val() as string
    const decimalDiscountComplement = 1 - discountPercentage / 100
    const unitPrice = $(option.element!).data('unitPrice')
    const totalPrice =
      $(option.element!).data('totalPrice') || unitPrice * Number(quantity)

    // Expecting a single &nbsp; between the texts to float
    const texts = option.text.split('\xa0')
    if (texts.length === 2) {
      const leftText =
        unitPrice && decimalDiscountComplement < 1 && parseInt(quantity) !== 1
          ? // Show price ea after strikethrough price after the quantity.
            // Since we show the total price on the right of each option also,
            // it's redundant to show this for a quantity of 1.
            '<span>' +
            quantity +
            ' (<span class="p-price p-price--discount">' +
            FormatUtils.formatMoney(unitPrice) +
            '</span> <span class="p-discount-percent-pre">' +
            FormatUtils.formatMoney(unitPrice * decimalDiscountComplement) +
            ' ea</span>)</span>'
          : '<span>' + texts[0] + '</span>'

      const rightText =
        decimalDiscountComplement < 1
          ? '<span class="pull-right"><span class="p-price p-price--discount">' +
            FormatUtils.formatMoney(totalPrice) +
            '</span> <span class="p-discount-percent-pre">' +
            FormatUtils.formatMoney(totalPrice * decimalDiscountComplement) +
            '</span></span>'
          : '<span class="pull-right">' + texts[1] + '</span>'

      // Since these are floated, we need to clear the floats in order to occupy space,
      // but the selects are added dynamically, so just add space in markup.
      // https://stackoverflow.com/questions/33372298/select2-js-how-to-align-two-items-inside-option-element#comment54540066_33372626
      return $(leftText + rightText + '<br/>')
    } else {
      return $('<span>' + option.text + '</span>')
    }
  },

  priceDelimiter(
    $selector: JQuery<HTMLElement>,
    discountPercentage: number
  ): JQuery<HTMLElement> {
    return $selector.select2({
      minimumResultsForSearch: Infinity,
      templateSelection: (option: IdTextPair | LoadingData) =>
        this.priceTemplate(option, discountPercentage),
      templateResult: (option: IdTextPair | LoadingData) =>
        this.priceTemplate(option, discountPercentage)
    })
  }
}
